"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const oxygen_utils_1 = require("@8x8/oxygen-utils");
const getIconColor_1 = require("../styled/getIconColor");
const IconButtonStyled_1 = require("../styled/IconButtonStyled");
const IconButton = ({ children, isDisabled, theme, forwardedRef, testId, onClick, onKeyDown, ...rest }) => {
    const buttonProps = {
        ...(isDisabled && { 'aria-disabled': true }),
    };
    const iconProps = {
        color: (0, getIconColor_1.getIconColor)({ isInverted: rest.isInverted, isDisabled, theme }),
    };
    const handleOnClick = (ev) => {
        if (isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (onClick) {
            onClick(ev);
        }
    };
    const handleOnKeyDown = (ev) => {
        if (((0, oxygen_utils_1.isSpaceEvent)(ev) || (0, oxygen_utils_1.isEnterEvent)(ev)) && isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (onKeyDown) {
            onKeyDown(ev);
        }
    };
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(IconButtonStyled_1.IconButtonStyled, { type: "button", onClick: handleOnClick, onKeyDown: handleOnKeyDown, ...(0, oxygen_config_1.getTestAttributes)(testId), ...rest, ...buttonProps, ref: forwardedRef }, react_1.default.Children.map(children || null, child => {
            if (react_1.default.isValidElement(child)) {
                return react_1.default.cloneElement(child, { ...iconProps });
            }
            return child;
        }))));
};
IconButton.propTypes = {
    children: prop_types_1.default.node.isRequired,
    isActive: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    isInverted: prop_types_1.default.bool,
    testId: prop_types_1.default.string,
};
IconButton.defaultProps = {
    isActive: false,
    isDisabled: false,
    isInverted: false,
    testId: 'iconButton',
};
exports.default = (0, oxygen_config_1.withTheme)(IconButton, 'iconButton');
